import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { clearTipDraft } from "@/store/useTipDraftStore";

function SelectedSplitTheBill() {
  const { t } = useTranslation();
  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();
  const { selectedAmount, remainingAmount } = useVenuesDataStore();

  // Back before the tip means starting the tip over.
  useEffect(() => {
    clearTipDraft();
  }, []);

  const handleOnConfirm = () => {
    if (selectedAmount * 100 > remainingAmount) {
      handleNavigate(
        `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/extra-tip`,
      );
    } else {
      handleNavigate(
        `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/leave-tip`,
      );
    }
  };

  return (
    <div className={styles.selectedSplitTheBillWrapper}>
      <div className={styles.selectedSplitTheBillHeader}>
        <p className={`body-bold-medium ${styles.selectedSplitTheBillTitle}`}>
          {t("transparentDrawer.title.youArePaying")}
        </p>
        <p className={`body-medium ${styles.selectedSplitTheBillPrice}`}>
          {selectedAmount.toFixed(2)} zł
        </p>
      </div>
      <Button
        onClick={handleOnConfirm}
        label={t("transparentDrawer.button.confirm")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
        disabled={selectedAmount === 0}
      />
    </div>
  );
}

export default SelectedSplitTheBill;
